import styled from 'styled-components';

export const Container = styled.div`
  background: ${(props) => props.color} !important;
  padding: 20px;
  border-radius: 4px;
  width: 100%;

  .containerTF {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
  }

  .icon {
    svg {
      color: #fff;
    }
  }
  .quantity {
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 30px;
    line-height: 40px;
    color: rgba(255, 255, 255, 0.85);
    cursor: default;
  }
`;
